import { Button, ButtonSize, ColourStateOutline } from '@ukpostbox/frontend-framework';
import { TipEventType } from '@ukpostbox/client-data';

function AccountTipEntry(item: TipEventType) {
	return (
		<div className='p-md' key={`tipItem-${item.id}`}>
			<h6 className='mb-xs'>{item.metadata.Title}</h6>
			<p>{item.metadata.Body}</p>
			{item?.metadata.Link && item?.metadata.LinkText && (
				<div className='mt-sm'>
					<Button
						title={item.metadata.LinkText}
						size={ButtonSize.Small}
						colour={ColourStateOutline.Secondary}
						squared
						actionLink={{
							title: item.metadata.LinkText,
							url: item.metadata.Link,
							target: '_blank',
							rel: 'noopener noreferrer',
						}}
					/>
				</div>
			)}
		</div>
	);
}

export { AccountTipEntry };
